import React, { useState, useEffect } from "react";
import mainLogo from "../assets/logo.svg";
import mobLogo from "../assets/Kancroo-logo.svg";
import LoadingImage from "../assets/Loading.gif";
import { BiCheckCircle } from "react-icons/bi";
import Loading from "../Loading";
import HTTP_BASE_URL from "../../constants/HttpConstants";
import { ToastContainer, toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import { Helmet } from "react-helmet-async";

const OTPVerify = () => {
  const navigate = useNavigate();
  const [mobile, setMobile] = useState("");
  const [verifyOtp, setVerifyOtp] = useState(true);
  const [successOtp, setSuccessOtp] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  const [otpNumber, setOtpNumber] = useState("");
  const [error, setError] = useState({});
  const [loadingImage, setLoadingImage] = useState(false);
  const [showResend, setShowResend] = useState(false);

  function pageLoad() {
    // Extract the 'mobile' parameter from the URL
    const urlParams = new URLSearchParams(window.location.search);
    const mobileParam = urlParams.get("mobile");
    setMobile(mobileParam || ""); // Set mobile or default to an empty string
  }

  const toastrOptions = {
    position: "top-center",
    autoClose: 1000,
    hideProgressBar: false,
    closeOnClick: false,
    pauseOnHover: true,
    draggable: true,
    progress: undefined,
    theme: "colored",
  };
  const otpVerifyLogin = async (event) => {
    event.preventDefault(); // Prevent default form behavior
    setLoadingImage(true);
    const newErrors = {};

    // Validate OTP field
    const otpError = validateField("otp", otpNumber);
    if (otpError) newErrors.otp = otpError;

    if (Object.keys(newErrors).length > 0) {
      setError(newErrors); // Update errors state
      toast.warning("Please enter a valid OTP.", { toastrOptions });
      setLoadingImage(false); // Stop loading on validation failure
      return;
    }

    setError({}); // Clear errors
    const formData = new FormData();
    formData.append("otp", otpNumber);
    formData.append("mobile", mobile);

    try {
      const response = await fetch(HTTP_BASE_URL + "verifyotp", {
        method: "POST",
        headers: {
          "access-token": "508b1430-68f0-4b2f-9003-3c2a0eb2a54a",
        },
        body: formData,
      });
      const result = await response.json();

      if (result?.code === 0) {
        localStorage.setItem("customertoken", result.data.access_token);
        localStorage.setItem("customerName", result.data.user_info.name);
        localStorage.setItem("customerMobile",result.data.user_info.mobile)
        setSuccessOtp(true);
        setVerifyOtp(false);
        toast.success("OTP verified successfully!", { toastrOptions });
        setTimeout(() => navigate("/all-booking"), 1500); // Slight delay for UX
        //  console.log(result.data.user_info.name)
      } else if (result?.code === 1) {
        toast.error("Incorrect OTP. Please try again.", { toastrOptions });
      } else {
        toast.error("An unexpected error occurred. Please try again later.", {
          toastrOptions,
        });
      }
    } catch (error) {
      console.error("Error sending OTP:", error);
      toast.error("Network error. Please try again.", { toastrOptions });
    } finally {
      setLoadingImage(false); // Stop loading...
    }
  };
  const OtpOnChange = (e) => {
    const { name, value } = e.target;
    setOtpNumber(value); // Update OTP state

    // Validate field and update errors
    const errorMessage = validateField(name, value);
    setError((prevErrors) => ({
      ...prevErrors,
      [name]: errorMessage, // Update only the specific field's error
    }));
  };
  const validateField = (name, value) => {
    let errorMessage = "";
    if (name === "otp") {
      if (!value) {
        errorMessage = "Please enter the OTP.";
      } else if (!/^[0-9]{6}$/.test(value)) {
        errorMessage = "OTP must be exactly 6 digits.";
      }
    }
    return errorMessage;
  };

  const resendOTP = async() => {

    const formData = new FormData();
    formData.append("mobile", mobile);
    try {
      await fetch(HTTP_BASE_URL + "customerlogin", {
        method: "post",
        headers: {
          "access-token": "508b1430-68f0-4b2f-9003-3c2a0eb2a54a",
        },
        body: formData,
      })
        .then((response) => response.json())
        .then((result) => {
            if(result.code === 0){
                toast.success('OTP has been sent successfully!', { toastrOptions })
                // console.log(result.data);
            }
        });
    } catch (error) {
      console.error("Error sending OTP:", error);
    }
  };

  useEffect(() => {
    pageLoad();
    const timer = setTimeout(() => {
      setIsLoading(false);
    }, 1200);
    const resendText = setTimeout(() => {
      setShowResend(true);
    }, 240000); // 4 minutes (240000ms)
    return () => {
      clearTimeout(timer);
      clearTimeout(resendText);
    };
  }, []);

  return (
    <>
      <Helmet>
        <title> My Account</title>
      </Helmet>
      <ToastContainer
        position="top-center"
        autoClose={1000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick={false}
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="colored"
      />

      {isLoading ? (
        <Loading />
      ) : (
        <div>
          <div className="container-fluid bg-white p-0 relative">
            <span className="navbar-brand d-none d-lg-block">
              <img
                className="logo-image success-logo"
                src={mainLogo}
                alt="Represents our brand's identity and commitment to quality."
                width={166}
                height={166}
                loading="eager"
              />
            </span>
            <div className="container mob-header">
              <nav className="navbar p-lg-0">
                <div className="container-fluid justify-content-center p-0">
                  <div className="navbar-logo d-lg-none">
                    <img
                      className="img-fluid"
                      src={mobLogo}
                      width={82}
                      height={85}
                      loading="eager"
                      alt="Logo for Kancaroo Trusted Car Carriers, featuring a sleek design with a car silhouette and the company name."
                    />
                  </div>
                </div>
              </nav>
            </div>
          </div>
          <div className="container-fluid booking-section login-banner">
            <div className="container">
              <div className="loginModel">
                {verifyOtp && (
                  <div className="loginContent gstModal-content">
                    <p className="mainHeading red text-center"> Verify OTP</p>
                    <form onSubmit={otpVerifyLogin}>
                      <div className="form-col p-0">
                        <label htmlFor="otp" className="form-label">
                          Enter OTP <span className="req-span">*</span>
                        </label>
                        <input
                          type="number"
                          name="otp"
                          id="otp"
                          value={otpNumber || ""}
                          onChange={OtpOnChange}
                          className="form-control"
                          placeholder="Eg: 9112"
                        />
                        {error.otp && (
                          <p className="text-para red">{error.otp}</p>
                        )}
                        <p className="text-para f-12 pt-2 text-center login-para">
                          By logging in, I agree to terms and privacy policy
                        </p>
                      </div>
                      <div className="pt-lg-4 pt-2 pb-1 otp">
                        <button
                          type="submit"
                          className="submit-btn"
                          disabled={loadingImage}
                        >
                          {loadingImage ? (
                            <>
                              <span className="sub-loading">
                                <img
                                  src={LoadingImage}
                                  alt="Progress indicator"
                                  width={25}
                                  height={25}
                                  loading="eager"
                                />
                              </span>{" "}
                              Verify OTP
                            </>
                          ) : (
                            "Verify OTP"
                          )}
                        </button>
                      </div>
                    </form>
                    {showResend && (
                      <button
                        className="text-para text-end p-0 red w-100"
                        onClick={() => resendOTP()}
                      >
                        Resend OTP
                      </button>
                    )}
                  </div>
                )}

                {successOtp && (
                  <div className="loginContent gstModal-content text-center pt-4 pb-4">
                    <BiCheckCircle
                      style={{
                        width: "58px",
                        height: "58px",
                        color: "#0FA958",
                      }}
                    />
                    <p className="mainHeading green "> Verified</p>
                    <p className="addGst black pt-2">
                      Your mobile verified successfully.
                      <br />
                      You will be redirected to Customer Portal shortly...
                    </p>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default OTPVerify;
